
<template>
  <div>
    <v-row class="pa-2 px-3">
      <v-btn icon large @click="toggleAudio()"><v-icon>{{isPlaying? 'mdi-pause' : 'mdi-play'}}</v-icon></v-btn>
      <audio style="display:none" ref="player" id="audio-player">
        <source :src="media_url" type="audio/mpeg">
        Your browser does not support the audio tag.
      </audio>
      <v-col class="pa-0">
        <v-slider color="white" class="mt-2" v-model="playbackTime" step="0" :max="audioDuration" hide-details></v-slider>
        <div v-show="audioLoaded" class=" mt-n2 ">
          <span v-if="isPlaying || playbackTime > 0" class="caption" v-html="elapsedTime()"> 00:00 </span>
          <span v-if="!isPlaying && playbackTime < 1" class="caption" v-html="totalTime()"> 00:00 </span>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'

export default {
  name: "AudioPlayer",
  props: {
    media_url: {
      type: String,
    },
  },
  data() {
    return {
      playbackTime: 0,
      audioDuration: 100,
      audioLoaded: false,
      isPlaying: false,
      listenerActive: false,
    }
  },
  methods: {
    toggleAudio() {
      var audio = this.$refs.player;
      //var audio = document.getElementById("audio-player");
      if (audio.paused) {
        audio.play();
        this.isPlaying = true;
      } else {
        audio.pause();
        this.isPlaying = false;
      }
    },
    initSlider() {
      var audio = this.$refs.player;
      if (audio) {
        this.audioDuration = audio.duration;
      }
    },
    //Convert audio current time from seconds to min:sec display
    convertTime(seconds){
      var date = new Date(0);
      date.setSeconds(seconds); // specify value for SECONDS here
      var timeString = date.toISOString().substr(14, 5);
      
      return timeString
    },
    //Show the total duration of audio file
    totalTime() {
      var audio = this.$refs.player;
      if (audio) {
        var seconds = audio.duration;
        // console.log({seconds});
        seconds = Math.round(seconds)
        return this.convertTime(seconds);
      } else {
        return '0:00';
      }
    },
    //Display the audio time elapsed so far
    elapsedTime() {
      var audio = this.$refs.player;
      if (audio) {
        var seconds = audio.currentTime;
        return this.convertTime(seconds);
      } else {
        return '0:00';
      }
    },
    //Playback listener function runs every 100ms while audio is playing
    playbackListener(e) {
      // console.log('playbackListener');
      var audio = this.$refs.player;
      //Sync local 'playbackTime' var to audio.currentTime and update global state
      this.playbackTime = audio.currentTime;
      // console.log({playbackTime: this.playbackTime, currentTime: audio.currentTime});
      
      //console.log("update: " + audio.currentTime);
      //Add listeners for audio pause and audio end events
      audio.addEventListener("ended", this.endListener);
      audio.addEventListener("pause", this.pauseListener);
    },
    //Function to run when audio is paused by user
    pauseListener() {
      this.isPlaying = false;
      this.listenerActive = false;
      this.cleanupListeners();
    },
    //Function to run when audio play reaches the end of file
    endListener() {
      this.isPlaying = false;
      this.listenerActive = false;
      this.cleanupListeners();
    },
    //Remove listeners after audio play stops
    cleanupListeners() {
      var audio = this.$refs.player;
      audio.removeEventListener("timeupdate", this.playbackListener);
      // audio.removeEventListener("freqtimeupdate", this.playbackListener);
      audio.removeEventListener("ended", this.endListener);
      audio.removeEventListener("pause", this.pauseListener);
      //console.log("All cleaned up!");
    },
    ...mapActions({
      // function: 'Module/action'
    })
  },
  mounted () {
    this.$nextTick(function() {
      var audio=this.$refs.player;
      // console.log({audio});
      //Wait for audio to load, then run initSlider() to get audio duration and set the max value of our slider 
      // "loademetadata" Event https://www.w3schools.com/tags/av_event_loadedmetadata.asp
      audio.addEventListener("loadedmetadata", function(e) {
          this.initSlider();
        }.bind(this)
      );
      // "canplay" HTML Event lets us know audio is ready for play https://www.w3schools.com/tags/av_event_canplay.asp
      audio.addEventListener("canplay", function(e) {
          this.audioLoaded=true;
        }.bind(this)
      );
      //Wait for audio to begin play, then start playback listener function
      this.$watch("isPlaying",function() {
        if(this.isPlaying) {
          // console.log('TOCANDO');
          // console.log('listenerActive', this.listenerActive);
          var audio=this.$refs.player;
          this.initSlider();
          //console.log("Audio playback started.");
          //prevent starting multiple listeners at the same time
          if(!this.listenerActive) {
            this.listenerActive=true;
            // console.log('listenerActive', this.listenerActive);
            audio.addEventListener("timeupdate", this.playbackListener);
            // audio.addEventListener("freqtimeupdate", this.playbackListener);
          }
        }
      });
      //Update current audio position when user drags progress slider
      this.$watch("playbackTime",function() {
        var audio=this.$refs.player;
        var diff=Math.abs(this.playbackTime-this.$refs.player.currentTime);
        
        //Throttle synchronization to prevent infinite loop between playback listener and this watcher
        if(diff>0.01) {
          this.$refs.player.currentTime=this.playbackTime;
        }
      });
    });
  },
  computed: {
    name() {
      return null 
    },
    ...mapState({
      // data: state=> state.Module.state_var
    })
  },
  watch: {
    data(nv,ov) {
      if (nv){
      } else if (nv == false){
      }
    }
  },
}
</script>

<style scoped>

</style>